import { render, staticRenderFns } from "./Recession.vue?vue&type=template&id=3114902e&scoped=true"
import script from "./Recession.vue?vue&type=script&lang=js"
export * from "./Recession.vue?vue&type=script&lang=js"
import style0 from "./Recession.vue?vue&type=style&index=0&id=3114902e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3114902e",
  null
  
)

export default component.exports